import { combineTokens, makeSurfaceToken } from '@utils/css';

const linkSurface = makeSurfaceToken("--slider-link", {
  color: "255 255 255",
  background: "0 0 0 / 0.8"
});
const tokens = combineTokens("--slide", {
  aspectRatio: "16 / 9"
});
const wrapper = "_b7nw1woot2p";
const imageButton = "_b7ni13iaji5";
const container = "_b7nc1k0gl1t";
const link = "_b7nl177m7iy";

export { container, imageButton, link, linkSurface, tokens, wrapper };
import "./atom.slide.style.linaria.module.css";
//# sourceMappingURL=atom.slide.style.js.map
